import React from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

import { Theme } from '../Theme';

import DentiraIcon from './../../../assets/icons/dentira_logo.svg';

import { history } from '../../../commons/utils';

const DentiraLogoContainer = styled.div`
	min-width: 265px;
	cursor: pointer;
	align-self: flex-end;
	display: flex;
	flex-direction: row;
	font-weight: 500;
	font-size: 20px;
	font-family: 'Prompt', sans-serif;
	${media.lessThan('1280px')`
        padding-top: 5px;
    `}
`;

export const DentiraLogo = () => {
	return (
		<DentiraLogoContainer
			onClick={() => {
				history.push('/');
			}}
			style={{ alignSelf: 'center' }}
		>
			<img
				alt='logo'
				style={{ alignSelf: 'center' }}
				src={DentiraIcon}
			/>
			<div style={{ alignSelf: 'center' }}>Seller Portal</div>
		</DentiraLogoContainer>
	);
};
